import { v4 as uuidv4 } from 'uuid';

import { IViolationEliminations } from 'APIPackage/KnmModule/interfaces/IKnmRequirementViolation';
import {
  IKnmErknmFormViolationFix,
  IViolationEliminationFormAttachment,
  IViolationMaterialTypeItem,
} from 'KnmErknmPackage/ErknmViolationsModule/interfaces/IKnmErknmFormViolation';
import { createViolationMaterialTypeSelectOption } from 'CorePackage/CatalogsModule/common/createViolationMaterialTypeSelectOption';
import { createViolationFixMethodSelectOption } from 'CorePackage/CatalogsModule/common/createViolationFixMethodSelectOption';
import { createViolationFixGradeSelectOption } from 'CorePackage/CatalogsModule/common/createViolationFixGradeSelectOption';
import { fixGradesStaticCatalog } from 'APIPackage/CatalogsModule/services/violationFixApi';

import { handleReactQuillDeltaValue } from '../../../functions/handleReactQuillDeltaValue';

export function convertKnmDataViolationFixesToFormValues(
  violationFixesData: IViolationEliminations[],
): IKnmErknmFormViolationFix[] {
  return violationFixesData.map(fixData => {
    const foundFixGrade = fixData.grade
      ? fixGradesStaticCatalog.find(grade => grade.code === fixData.grade) || null
      : null;

    return {
      id: fixData.guid || uuidv4(),
      isNew: !!fixData.isNew,
      type: fixData.materialType?.length
        ? fixData.materialType.map<IViolationMaterialTypeItem>(typeDTO => ({
            isNew: !!typeDTO.isNew,
            value: createViolationMaterialTypeSelectOption(typeDTO),
          }))
        : null,
      method: fixData.actualMethod ? createViolationFixMethodSelectOption(fixData.actualMethod) : null,
      isMethodFromMobile: fixData.actualMethodFromMobile,
      grade: foundFixGrade ? createViolationFixGradeSelectOption(foundFixGrade) : null,
      explanationGrade: fixData.descriptionGrade,
      explanationMaterial: fixData.descriptionMaterial,
      explanationMaterialReactQuillEditor: handleReactQuillDeltaValue(
        fixData.descriptionMaterialReactQuillEditor || fixData.descriptionMaterial,
      ),
      attachments: fixData.attachments?.length
        ? fixData.attachments?.map<IViolationEliminationFormAttachment>(attachmentItemData => ({
            ...attachmentItemData,
            attachment: attachmentItemData.attachment
              ? {
                  ...attachmentItemData.attachment,
                  isNew: false,
                }
              : null,
            isNew: false,
          }))
        : null,
    };
  });
}
